export const attendantsApi = {
  attendants: {
    queryKey: (params?: string[]) => ["attendants", ...(params || [])],
    route: () => `attendants`,
    methods: ["GET", "POST"],
  },
  attendant: {
    queryKey: (id: number, params?: string[]) => [
      "attendants",
      id,
      ...(params || []),
    ],
    route: (id: number) => `attendants/${id}`,
    methods: ["PATCH", "DELETE"],
  },
};
